const CryptoJs = window.CryptoJS
const ENCRYPT_KEY = 'fxEncrytpKey2005'

const encrypt = function (word) {
	let key = CryptoJs.enc.Utf8.parse(ENCRYPT_KEY)
	let srcs = CryptoJs.enc.Utf8.parse(word)
	let encrypted = CryptoJs.AES.encrypt(srcs, key, {
		mode: CryptoJs.mode.ECB,
		padding: CryptoJs.pad.Pkcs7
	})
	return encrypted.toString()
}

const decrypt = function (word) {
	let key = CryptoJs.enc.Utf8.parse(ENCRYPT_KEY)
	let decrypt = CryptoJs.AES.decrypt(word, key, {
		mode: CryptoJs.mode.ECB,
		padding: CryptoJs.pad.Pkcs7
	})
	return CryptoJs.enc.Utf8.stringify(decrypt).toString()
}
export default {
	encrypt,
	decrypt
}



// WEBPACK FOOTER //
// ./src/lib/util/src/encrypt.js